//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import M_DCM_BASIC_01 from './M_DCM_BASIC_01';
import { useDispatch, useSelector } from 'react-redux';
import Commons from '../../../Services/Common/Common';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import Global from '../../../Services/Common/Global';
import { Loading } from '../../../Components/MUIs';
import dayjs from 'dayjs';
import { GetTabConfig } from '../config/TabConfig';
import { useSearch1, useSearch2, useSearch3 } from './M_DCM_BASIC_01_Query';
import {
  PrintLogic1 as RIS_BASIC_01_PrintLogic1,
  PrintLogic3 as RIS_BASIC_01_PrintLogic3,
} from '../Other/RIS_BASIC_01F';
import {
  PrintLogic1 as RIS_BASIC_02_PrintLogic1,
  PrintLogic2 as RIS_BASIC_02_PrintLogic2,
  PrintLogic3 as RIS_BASIC_02_PrintLogic3,
  PrintLogic4 as RIS_BASIC_02_PrintLogic4,
} from '../Other/RIS_BASIC_02F';
import { PrintLogic1 as PPE_BASIC_02_PrintLogic1 } from '../Other/PPE_BASIC_02F';
import { PrintLogic1 as POL_BASIC_02_PrintLogic1 } from '../Other/POL_BASIC_02F';
import { PrintLogic1 as PPE_BASIC_03_PrintLogic1 } from '../Other/PPE_BASIC_03F';
import {
  PrintLogic1 as BUD_BASIC_01_PrintLogic1,
  SearchLogic1 as BUD_BASIC_01_SearchLogic1,
} from '../Other/BUD_BASIC_01F';
import {
  PrintLogic1 as BUD_BASIC_02_PrintLogic1,
  PrintLogic3 as BUD_BASIC_02_PrintLogic3,
  SearchLogic1 as BUD_BASIC_02_SearchLogic1,
} from '../Other/BUD_BASIC_02F';
import { PrintLogic1 as SUB_BASIC_01_PrintLogic1 } from '../Other/SUB_BASIC_01F';
import { PrintLogic1 as SUB_BASIC_02_PrintLogic1 } from '../Other/SUB_BASIC_02F';
import { PrintLogic1 as SUB_BASIC_03_PrintLogic1 } from '../Other/SUB_BASIC_03F';
import { PrintLogic3 as SAC_BASIC_PrintLogic3 } from '../Other/SAC_BASICF';
import {
  PrintLogic1 as HEA_BASIC_01_PrintLogic1,
  PrintLogic2 as HEA_BASIC_01_PrintLogic2,
} from '../Other/HEA_BASIC_01F';
import {
  PrintLogic1 as HEA_BASIC_02_PrintLogic1,
  PrintLogic2 as HEA_BASIC_02_PrintLogic2,
} from '../Other/HEA_BASIC_02F';
import { PrintLogic1 as HAZ_BASIC_01_PrintLogic1 } from '../Other/HAZ_BASIC_01F';
import { PrintLogic1 as HAZ_BASIC_03_PrintLogic1 } from '../Other/HAZ_BASIC_03F';
import { PrintLogic1 as LEG_BASIC_PrintLogic1 } from '../Other/LEG_BASICF';
import { PrintLogic1 as SER_BASIC_PrintLogic1 } from '../Other/SER_BASICF';
import {
  PrintLogic1 as SAM_BASIC_02_PrintLogic1,
  SearchLogic1 as SAM_BASIC_02_SearchLogic1,
} from '../Other/SAM_BASIC_02F';
import {
  PrintLogic1 as SAF_BASIC_02_PrintLogic1,
  SearchLogic1 as SAF_BASIC_02_SearchLogic1,
} from '../Other/SAF_BASIC_02F';
import {
  PrintLogic1 as TRA_CUSTOM_01_PrintLogic1,
} from '../Other/TRA_CUSTOM_01F';
import {
  PrintLogic1 as TRA_CUSTOM_02_PrintLogic1,
} from '../Other/TRA_CUSTOM_02F';
import { PrintLogic1 as TRA_BASIC_01_PrintLogic1 } from '../Other/TRA_BASIC_01F';
import { PrintLogic1 as SAT_BASIC_01_PrintLogic1 } from '../Other/SAT_BASIC_01F';
import {
  PrintLogic1 as SAT_BASIC_02_PrintLogic1,
  SearchLogic1 as SAT_BASIC_02_SearchLogic1,
} from '../Other/SAT_BASIC_02F';
import {
  PrintLogic1 as SAT_BASIC_03_PrintLogic1,
  SearchLogic1 as SAT_BASIC_03_SearchLogic1,
} from '../Other/SAT_BASIC_03F';
import {
  PrintLogic1 as SAT_BASIC_04_PrintLogic1,
} from '../Other/SAT_BASIC_04F';
import {
  PrintLogic1 as SAT_BASIC_05_PrintLogic1,
  SearchLogic1 as SAT_BASIC_05_SearchLogic1,
} from '../Other/SAT_BASIC_05F';
import {
  PrintLogic1 as HAM_BASIC_02_PrintLogic1,
  SearchLogic1 as HAM_BASIC_02_SearchLogic1,
} from '../Other/HAM_BASIC_02F';
import { PrintLogic1 as SAP_BASIC_01_PrintLogic1 } from '../Other/SAP_BASIC_01F';
import {
  PrintLogic1 as SAP_BASIC_02_PrintLogic1,
  SearchLogic3 as SAP_BASIC_02_SearchLogic3,
  PrintLogic2 as SAP_BASIC_02_PrintLogic2,
} from '../Other/SAP_BASIC_02F';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

export default function M_DCM_BASIC_01F({ mainMenuId, subMenuId, onBack }) {
  //#region 변수
  const {
    userInfo,
    custInfo: baseCustInfo,
    companyInfo: baseCompanyInfo,
  } = useSelector((state) => state.BaseInfo);
  const activeStep = useSelector((state) => state.common.activeStep);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [rowData1, setRowData1] = useState([]); // 단일 리스트용
  const [rowDataList, setRowDataList] = useState([]); // 탭별 리스트용
  const [value, setValue] = useState(0);
  const [tabLabels, setTabLabels] = useState([]);
  const [tabList, setTabList] = useState([]); // 탭 정보 전체 (tabId, tabNm 포함)
  const [tabConfigs, setTabConfigs] = useState([]); // 탭별 설정 배열
  const [depList, setDepList] = useState([]); // 부서 목록
  const [initialLoad, setInitialLoad] = useState(true); // 초기 로드 여부
  const [custList, setCustList] = useState([]); // 사업장 리스트(목록)
  const imgRef = useRef(''); // 이미지용 ref (PPE_BASIC_02, SUB_BASIC_03에서 사용)

  const searchRef = useRef({
    mainMenuId: null,
    subMenuId: null,
    searchText: '',
    depCd: '',
    depName: '',
    // 기본값: 시작날짜 = 오늘 - 3년, 종료날짜 = 오늘
    startDate: dayjs().subtract(3, 'year').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
    coCd: '', // ADMIN인 경우 사용
    currentYear: new Date().getFullYear().toString(), // 안전보건목표 및 추진계획용
    quarter: Math.ceil((new Date().getMonth() + 1) / 3).toString(), // 안전보건목표 및 추진계획용
    custCd: '', // 선택된 사업장 코드
    custList: [], // 사업장 목록
  });
  //#endregion

  //#region 쿼리 훅
  // 사업장 조회
  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      const data = rows?.data ?? rows;

      if (!Array.isArray(data)) {
        setCustList([]);
        searchRef.current.custList = [];
        return;
      }
      if (data.length === 0) {
        setCustList([]);
        searchRef.current.custList = [];
      } else if (data[0]?.type === 'Error') {
        throw new Error(data[0].message);
      } else {
        data.forEach((item) => {
          if (item.custCd) {
            item.value = item.custCd;
            item.label = item.custNm;
          }
        });
        const processedData = Commons.InsertNumber(data);
        setCustList(processedData);
        searchRef.current.custList = processedData;

        // 첫 번째 사업장을 기본값으로 설정
        if (processedData.length > 0 && !searchRef.current.custCd) {
          searchRef.current.custCd = processedData[0].value;
        }
      }
    },
    onError: (e) => {
      console.log(e);
      setCustList([]);
      searchRef.current.custList = [];
    },
  });

  // 부서 조회
  const { runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      const data = rows?.data ?? rows;

      if (data.length > 0 && data[0].type !== 'Error') {
        const depListData = data.map((item) => ({
          name: item.depNmLast,
          value: item.depCd,
        }));
        setDepList(depListData);

        // 첫 번째 부서를 기본값으로 설정
        if (depListData.length > 0 && !searchRef.current.depCd) {
          searchRef.current.depCd = depListData[0].value;
        }
      } else {
        setDepList([]);
      }
    },
    onError: (e) => {
      console.error(e);
      setDepList([]);
    },
  });

  // 탭 조회
  const { runAsync: Search3Async } = useSearch3({
    onSuccess: (rows) => {
      const data = rows?.data ?? rows;

      if (!Array.isArray(data)) {
        setTabLabels([]);
        setTabList([]);
        return;
      }

      // 현재 선택된 메뉴 ID (subMenuId 우선, 없으면 mainMenuId)
      const currentMenuId = subMenuId || mainMenuId;

      //#region 임시 필터링 코드 (다른 웹페이지 작업 미완료로 인한 숨김 처리 작업 완료 시 원복)
      // menuId로 필터링하고 seq로 정렬
      const filtered = data
        .filter((item) => item.menuId === currentMenuId)
        .sort((a, b) => (a.seq || 0) - (b.seq || 0));
      //#endregion

      if (filtered.length > 0) {
        // 탭 정보 저장 (tabId, tabNm 포함)
        setTabList(filtered);
        // 탭 레이블 추출
        const labels = filtered.map((item) => item.tabNm);
        setTabLabels(labels);
        // 탭별 설정 생성
        const configs = filtered.map((tab) =>
          GetTabConfig(tab.tabId, currentMenuId)
        );
        setTabConfigs(configs);
        // 탭별 데이터 배열 초기화
        setRowDataList(new Array(labels.length).fill([]));
      } else {
        // 탭이 없으면 단일 리스트
        setTabLabels([]);
        setTabList([]);
        // 탭이 없는 경우 메뉴 ID로 설정 생성
        const config = GetTabConfig(null, currentMenuId);
        setTabConfigs([config]);
        setRowDataList([]);
      }
    },
    onError: (e) => {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
      setTabLabels([]);
      setTabList([]);
    },
  });
  //#endregion

  useEffect(() => {
    if (mainMenuId || subMenuId) {
      searchRef.current.mainMenuId = mainMenuId;
      searchRef.current.subMenuId = subMenuId;
      // 탭 정보 조회
      Search3Async();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainMenuId, subMenuId]);

  // 탭 정보가 변경되면 초기 로드 플래그 리셋
  useEffect(() => {
    if (tabLabels.length > 0) {
      setInitialLoad(true);
    }
  }, [tabLabels.length]);

  // 데이터 조회 (초기 로드 시 첫 번째 탭만, 이후에는 선택된 탭만)
  useEffect(() => {
    if (!userInfo || !userInfo.coCd) return;

    const ChangeValue = async () => {
      setLoading(true);
      try {
        await Search1Async();

        // 부서 조회가 끝난 뒤에 SearchLogic2 호출 (depCd가 procedureParams에 들어가도록)
        if (searchRef.current.custCd) {
          await SearchDep(searchRef.current.custCd);
        }

        if (!searchRef.current.mainMenuId && !searchRef.current.subMenuId)
          return;
        if (tabLabels.length > 0) {
          // 탭이 있는 경우 - 초기 로드 시 첫 번째 탭만, 이후에는 선택된 탭만 조회
          if (initialLoad) {
            // 초기 로드: 첫 번째 탭만 조회
            await SearchLogic2(0);
            setInitialLoad(false);
          } else {
            // 탭 클릭 시: 선택된 탭만 조회
            await SearchLogic2(value);
          }
        } else {
          // 탭이 없는 경우 - 단일 데이터 조회
          await SearchLogic2();
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    ChangeValue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, userInfo, mainMenuId, subMenuId, initialLoad, tabLabels.length]);
  //#endregion

  //#region 조회
  // 부서 조회 (authCd 체크 포함)
  const SearchDep = async (custCd) => {
    try {
      if (['BUSINESS_OWNER', 'HEAD_MANAGER'].includes(userInfo.authCd)) {
        await Search2Async({ custCd: custCd });
      } else {
        // 일반 사용자는 자신의 부서만
        const singleDep = {
          name: userInfo.depNm,
          value: userInfo.depCd,
        };
        setDepList([singleDep]);
        searchRef.current.depCd = userInfo.depCd || '';
        searchRef.current.depName = userInfo.depNm || '';
      }
    } catch (e) {
      console.error(e);
      setDepList([]);
    }
  };

  // 문서 조회
  const SearchLogic2 = async (tabIndex = null) => {
    setLoading(true);

    try {
      // 탭이 있는 경우 tabIndex가 null이면 안 됨
      const hasTabs = tabList.length > 0 || tabLabels.length > 0;
      if (hasTabs && tabIndex === null) {
        console.warn(
          'SearchLogic2 - 탭이 있는데 tabIndex가 null입니다. 첫 번째 탭(0)으로 설정합니다.'
        );
        tabIndex = 0;
      }

      const menuId =
        searchRef.current.subMenuId || searchRef.current.mainMenuId;
      if (!menuId) {
        if (tabIndex !== null) {
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = [];
            return newRowDataList;
          });
        } else {
          setRowData1([]);
        }
        return;
      }

      // 탭이 있는 경우 tabId 사용, 없는 경우 menuId 사용
      const tabInfo =
        tabIndex !== null && tabList[tabIndex] ? tabList[tabIndex] : null;
      const tabId = tabInfo?.tabId || null;
      const currentMenuId =
        searchRef.current.subMenuId || searchRef.current.mainMenuId;

      // 탭별 설정 가져오기 (이미 생성된 설정 사용 또는 새로 생성)
      const tabConfig =
        tabIndex !== null && tabConfigs[tabIndex]
          ? tabConfigs[tabIndex]
          : GetTabConfig(
            tabId,
            currentMenuId
          );

      // tabConfig가 없으면 조기 반환
      if (!tabConfig) {
        console.warn('SearchLogic2 - tabConfig가 없습니다:', {
          tabId,
          currentMenuId,
          tabIndex,
          tabConfigsLength: tabConfigs.length,
        });
        if (tabIndex !== null) {
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = [];
            return newRowDataList;
          });
        } else {
          setRowData1([]);
        }
        return;
      }

      // 프로시저 파라미터 구성
      const procedureParams = BuildProcedureParams(
        tabConfig,
        userInfo,
        tabId,
        currentMenuId
      );

      // BUD_BASIC_01 또는 BUD_BASIC_02인 경우 Other 폴더의 조회 함수 사용
      if (tabId === 'BUD_BASIC_01') {
        const processedData = await BUD_BASIC_01_SearchLogic1(
          tabConfig.apiUrl,
          procedureParams,
          dispatch,
          setLoading
        );

        if (tabIndex !== null) {
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = processedData;
            return newRowDataList;
          });
        } else {
          setRowData1(processedData);
        }
        return;
      }

      if (tabId === 'BUD_BASIC_02') {
        const processedData = await BUD_BASIC_02_SearchLogic1(
          tabConfig.apiUrl,
          procedureParams,
          dispatch,
          setLoading
        );

        if (tabIndex !== null) {
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = processedData;
            return newRowDataList;
          });
        } else {
          setRowData1(processedData);
        }
        return;
      }

      // SAM_BASIC_02인 경우 SearchLogic1 실행
      if (tabId === 'SAM_BASIC_02') {
        const processedData = await SAM_BASIC_02_SearchLogic1(
          tabConfig.apiUrl,
          procedureParams,
          dispatch,
          setLoading
        );

        if (tabIndex !== null) {
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = processedData;
            return newRowDataList;
          });
        } else {
          setRowData1(processedData);
        }
        return;
      }

      // SAF_BASIC_02인 경우 SearchLogic1 실행
      if (tabId === 'SAF_BASIC_02') {
        const processedData = await SAF_BASIC_02_SearchLogic1(
          {
            procedureName: tabConfig.procedureName,
            ...procedureParams,
          },
          dispatch,
          setLoading
        );

        if (tabIndex !== null) {
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = processedData;
            return newRowDataList;
          });
        } else {
          setRowData1(processedData);
        }
        return;
      }

      // SAT_BASIC_02인 경우 Other 폴더의 조회 함수 사용
      if (tabId === 'SAT_BASIC_02') {
        const processedData = await SAT_BASIC_02_SearchLogic1(
          tabConfig.apiUrl,
          procedureParams,
          dispatch,
          setLoading
        );

        if (tabIndex !== null) {
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = processedData;
            return newRowDataList;
          });
        } else {
          setRowData1(processedData);
        }
        return;
      }

      // SAT_BASIC_03인 경우 Other 폴더의 조회 함수 사용
      if (tabId === 'SAT_BASIC_03') {
        const processedData = await SAT_BASIC_03_SearchLogic1(
          tabConfig.apiUrl,
          procedureParams,
          dispatch,
          setLoading
        );

        if (tabIndex !== null) {
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = processedData;
            return newRowDataList;
          });
        } else {
          setRowData1(processedData);
        }
        return;
      }

      // SAT_BASIC_05인 경우 Other 폴더의 조회 함수 사용
      if (tabId === 'SAT_BASIC_05') {
        const processedData = await SAT_BASIC_05_SearchLogic1(
          tabConfig.apiUrl,
          procedureParams,
          dispatch,
          setLoading
        );

        if (tabIndex !== null) {
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = processedData;
            return newRowDataList;
          });
        } else {
          setRowData1(processedData);
        }
        return;
      }

      // HAM_BASIC_02인 경우 Other 폴더의 조회 함수 사용 (Master/Detail 분리)
      if (tabId === 'HAM_BASIC_02') {
        const result = await HAM_BASIC_02_SearchLogic1(
          tabConfig.apiUrl,
          procedureParams,
          dispatch,
          setLoading
        );

        // HAM_BASIC_02는 masterData, detailData, printGridData를 반환
        if (tabIndex !== null) {
          // 탭이 있는 경우 (일반적으로는 없을 것으로 예상되지만 처리)
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = result.printGridData;
            return newRowDataList;
          });
        } else {
          setRowData1(result.printGridData);
        }
        return;
      }

      // 일반 케이스: 기존 로직 사용
      const result = await apiRequest(
        'post',
        tabConfig.apiUrl,
        procedureParams
      );
      let data = result.data;

      if (!Array.isArray(data)) {
        // 배열이 아닌 경우 처리
        if (data && typeof data === 'object' && !data.type) {
          // 단일 객체인 경우 배열로 변환
          data = [data];
          console.log('SearchLogic2 - 단일 객체를 배열로 변환:', data);
        } else {
          if (tabIndex !== null) {
            setRowDataList((prev) => {
              const newRowDataList = [...prev];
              newRowDataList[tabIndex] = [];
              return newRowDataList;
            });
          } else {
            setRowData1([]);
          }
          return;
        }
      }

      if (data.length === 0) {
        if (tabIndex !== null) {
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = [];
            return newRowDataList;
          });
        } else {
          setRowData1([]);
        }
      } else if (data[0]?.type === 'Error') {
        dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
        return false;
      } else {
        let updatedData = Commons.InsertNumber(data);

        if (tabIndex !== null) {
          setRowDataList((prev) => {
            const newRowDataList = [...prev];
            newRowDataList[tabIndex] = updatedData;
            return newRowDataList;
          });
        } else {
          setRowData1(updatedData);
        }
      }
    }
    catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 함수
  // 프로시저 파라미터 구성 함수
  const BuildProcedureParams = (tabConfig, user, tabId, currentMenuId) => {
    const procedureParams = {};
    const parameterMapping = tabConfig.parameterMapping || {};

    // parameterMapping에 정의된 파라미터만 처리
    Object.keys(parameterMapping).forEach((paramKey) => {
      const mappedParamName = parameterMapping[paramKey];
      let paramValue = '';

      // 파라미터별 값 가져오기
      if (paramKey === 'coCd') {
        if (user.authCd === 'ADMIN' && searchRef.current.coCd) {
          paramValue = searchRef.current.coCd;
        } else if (user.coCd) {
          paramValue = user.coCd;
        }
      } else if (paramKey === 'searchText') {
        // _SEARCH_TEXT는 무조건 빈 문자열
        paramValue = '';
      } else if (paramKey === 'tabId') {
        if (tabId) {
          paramValue = tabId;
        }
      } else if (paramKey === 'menuId') {
        if (currentMenuId) {
          paramValue = currentMenuId;
        }
      } else if (paramKey === 'custCd') {
        // searchRef.current.custCd가 있으면 사용, 없으면 첫 번째 사업장 사용
        if (searchRef.current.custCd) {
          paramValue = searchRef.current.custCd;
        } else if (custList && custList.length > 0) {
          paramValue = custList[0].value;
        }
      } else if (paramKey === 'depCd') {
        // searchRef.current.depCd가 있으면 사용, 없으면 첫 번째 사업장 사용
        if (searchRef.current.depCd) {
          paramValue = searchRef.current.depCd;
        } else if (depList && depList.length > 0) {
          paramValue = depList[0].value;
        }
      } else if (
        paramKey === 'startDate'
      ) {
        // _startDate는 빈 문자열도 허용
        paramValue = searchRef.current.startDate || '';
      } else if (paramKey === 'endDate') {
        // _endDate는 빈 문자열도 허용
        paramValue = searchRef.current.endDate || '';
      } else if (paramKey === 'year') {
        paramValue =
          searchRef.current.currentYear || new Date().getFullYear().toString();
      } else if (paramKey === 'startYear') {
        // 년도 범위 필터 (시작년도)
        const currentYear = new Date().getFullYear();
        paramValue =
          searchRef.current.startYear || (currentYear - 1).toString();
      } else if (paramKey === 'endYear') {
        // 년도 범위 필터 (종료년도)
        paramValue =
          searchRef.current.endYear || new Date().getFullYear().toString();
      } else if (paramKey === 'quarter') {
        paramValue =
          searchRef.current.quarter ||
          Math.ceil((new Date().getMonth() + 1) / 3).toString();
      } else if (paramKey === 'month') {
        paramValue =
          searchRef.current.month || (new Date().getMonth() + 1).toString();
      } else if (paramKey === 'yearMonth') {
        // _YEAR_MONTH는 YYYY-MM 형식으로 조합
        const now = new Date();
        const year =
          searchRef.current.currentYear || now.getFullYear().toString();
        const month =
          searchRef.current.month || (now.getMonth() + 1).toString();
        // 월을 2자리로 포맷팅 (예: 1 -> 01, 12 -> 12)
        const formattedMonth = month.padStart(2, '0');
        paramValue = `${year}-${formattedMonth}`;
      } else if (paramKey === 'budType') {
        // BUD_BASIC_01에서는 '1', BUD_BASIC_02에서는 '0'
        if (tabId === 'BUD_BASIC_01') {
          paramValue = '1';
        } else if (tabId === 'BUD_BASIC_02') {
          paramValue = '0';
        }
      } else if (paramKey === 'userId') {
        // user.decUserId 사용
        if (user && user.decUserId) {
          paramValue = user.decUserId;
        }
      }

      // 값이 있거나 빈 문자열이어도 되는 경우에만 추가
      if (paramValue !== undefined && paramValue !== null) {
        // 빈 문자열이어도 되는 경우: _SEARCH_TEXT, _searchText, _startDate, _endDate, _START_DATE, _END_DATE, _depCd
        const allowEmpty =
          paramKey === 'searchText' ||
          paramKey === 'startDate' ||
          paramKey === 'endDate' ||
          paramKey === 'gubun';

        // 바텀시트에서 선택하지 않아도 기본값이 있어야 하는경우
        if (paramKey === 'coCd') {
          if (paramValue !== '') {
            procedureParams[mappedParamName] = Commons.EncryptAES(paramValue);
          }
        } else if (paramKey === 'custCd') {
          if (paramValue !== '') {
            procedureParams[mappedParamName] = Commons.EncryptAES(paramValue);
          }
        } else if (paramValue !== '' || allowEmpty) {
          procedureParams[mappedParamName] = Commons.EncryptAES(paramValue);
        }
      }
    });

    return procedureParams;
  };

  const HandleChipClick = (item) => {
    // 선택된 사업장 코드 저장
    searchRef.current.custCd = item.value || '';

    // chip 클릭 시 데이터 재조회
    const ChangeValue = async () => {
      setLoading(true);
      try {
        if (tabLabels.length > 0) {
          // 탭이 있는 경우 - 각 탭별로 데이터 조회
          const promises = tabLabels.map((label, index) => SearchLogic2(index));
          await Promise.all(promises);
        } else {
          // 탭이 없는 경우 - 단일 데이터 조회
          await SearchLogic2();
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    ChangeValue();
  };

  // PrintLogic 함수 (레포트 + 파일업로드 같이 쓰는 화면에서 사용)
  const PrintLogic1 = async (documentData) => {
    if (!documentData) {
      console.error('PrintLogic1: documentData가 없습니다.');
      return null;
    }

    try {
      const printData = {
        FileName: 'POL_BASIC_01', // 기본값 (나중에 fileName 필드로 확장 예정)
        HeaderData: JSON.stringify(documentData),
      };

      const response = await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      );

      // response.data가 blob인 경우 그대로 반환
      if (response.data instanceof Blob) {
        return response.data;
      }
      // response.data가 다른 형태인 경우 blob으로 변환
      else if (response.data) {
        return new Blob([response.data], { type: 'application/pdf' });
      } else {
        console.error('PrintLogic1: 응답 데이터가 없습니다.');
        return null;
      }
    } catch (e) {
      console.error('PrintLogic1 실행 실패:', e);
      dispatch(
        showSnackbar({
          message: e.message || '인쇄 데이터 생성에 실패했습니다.',
          type: 'error',
        })
      );
      return null;
    }
  };

  // OtherLogic 함수 (케이스별로 다른 로직 실행)
  const OtherLogic1 = async (documentData, printItem = null) => {
    // 현재 탭의 tabId 확인
    const currentTabIndex = tabLabels.length > 0 ? value : 0;
    const currentTab = tabList[currentTabIndex] || null;
    const tabId = currentTab?.tabId || null;
    const currentMenuId = subMenuId || mainMenuId;

    // RIS_BASIC_01인 경우 printItem에 따라 다른 인쇄 함수 실행
    if (tabId === 'RIS_BASIC_01') {
      // printItem이 있고 printType이 '1'이면 PrintLogic3 실행 (위험정보 조사표)
      if (printItem && printItem.printType === '1') {
        return await RIS_BASIC_01_PrintLogic3(
          documentData,
          dispatch,
          setLoading
        );
      }
      // printItem이 없으면 PrintLogic1 실행 (상단 인쇄 버튼)
      return await RIS_BASIC_01_PrintLogic1(
        null, // _value1 (사용하지 않음)
        dispatch,
        setLoading,
        searchRef
      );
    }

    // RIS_BASIC_02인 경우 printItem과 topPrintButtons에 따라 다른 인쇄 함수 실행
    if (tabId === 'RIS_BASIC_02') {
      // printItem이 있고 printType이 '1'이면 PrintLogic2 실행 (근로자 참여 체크리스트)
      // 이 경우 documentData가 필요함
      if (printItem && printItem.printType === '1') {
        if (!documentData) {
          dispatch(
            showSnackbar({
              message: '위험성평가표 항목을 선택하세요.',
              type: 'warning',
            })
          );
          return null;
        }
        return await RIS_BASIC_02_PrintLogic2(
          documentData,
          dispatch,
          setLoading,
          tabLabels.length > 0
            ? rowDataList[currentTabIndex] || []
            : rowData1 || [],
          searchRef
        );
      }
      // topPrintButtons의 printType에 따라 다른 함수 실행
      // 이 경우 documentData가 없어도 됨
      if (printItem && printItem.printType === '2') {
        // 위험성평가 결과서
        return await RIS_BASIC_02_PrintLogic1(
          documentData,
          dispatch,
          setLoading,
          searchRef
        );
      }
      if (printItem && printItem.printType === '3') {
        // 위험성평가 실시규정
        return await RIS_BASIC_02_PrintLogic4(
          null,
          dispatch,
          setLoading,
          searchRef
        );
      }
      if (printItem && printItem.printType === '4') {
        // 근로자참여 서명지
        return await RIS_BASIC_02_PrintLogic3(
          null,
          dispatch,
          setLoading,
          searchRef
        );
      }
      // 기본값 (없을 경우)
      return null;
    }

    // HEA_BASIC_01인 경우 printItem에 따라 다른 인쇄 함수 실행
    if (tabId === 'HEA_BASIC_01') {
      // printItem이 있고 printType이 '1'이면 PrintLogic1 실행 (일반건강진단)
      if (printItem && printItem.printType === '1') {
        return await HEA_BASIC_01_PrintLogic1(
          documentData,
          dispatch,
          setLoading,
          tabLabels.length > 0
            ? rowDataList[currentTabIndex] || []
            : rowData1 || [],
          searchRef,
          userInfo
        );
      }
      // printItem이 있고 printType이 '2'이면 PrintLogic2 실행 (건강진단 실시 지침서)
      if (printItem && printItem.printType === '2') {
        return await HEA_BASIC_01_PrintLogic2(
          null,
          dispatch,
          setLoading,
          searchRef
        );
      }
      // 기본값 (없을 경우)
      return null;
    }

    // HEA_BASIC_02인 경우 printItem에 따라 다른 인쇄 함수 실행
    if (tabId === 'HEA_BASIC_02') {
      // printItem이 있고 printType이 '1'이면 PrintLogic1 실행 (특수건강진단)
      if (printItem && printItem.printType === '1') {
        return await HEA_BASIC_02_PrintLogic1(
          documentData,
          dispatch,
          setLoading,
          tabLabels.length > 0
            ? rowDataList[currentTabIndex] || []
            : rowData1 || [],
          searchRef,
          userInfo
        );
      }
      // printItem이 있고 printType이 '2'이면 PrintLogic2 실행 (건강진단 실시 지침서)
      if (printItem && printItem.printType === '2') {
        return await HEA_BASIC_02_PrintLogic2(
          null,
          dispatch,
          setLoading,
          searchRef
        );
      }
      // 기본값 (없을 경우)
      return null;
    }

    // HAZ_BASIC_01인 경우 PrintLogic1 실행
    if (tabId === 'HAZ_BASIC_01') {
      return await HAZ_BASIC_01_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef,
        userInfo
      );
    }

    // HAZ_BASIC_03인 경우 PrintLogic1 실행
    if (tabId === 'HAZ_BASIC_03') {
      return await HAZ_BASIC_03_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef,
        userInfo
      );
    }

    // PPE_BASIC_02인 경우 PrintLogic1 실행
    if (tabId === 'PPE_BASIC_02') {
      return await PPE_BASIC_02_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        depList,
        [], // memberList는 현재 없으므로 빈 배열로 전달
        userInfo,
        searchRef,
        imgRef
      );
    }

    // POL_BASIC_02인 경우 PrintLogic1 실행
    if (tabId === 'POL_BASIC_02') {
      return await POL_BASIC_02_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        documentData || {} // inputs1은 헤더 데이터로 사용
      );
    }

    // PPE_BASIC_03인 경우 PrintLogic1 실행
    if (tabId === 'PPE_BASIC_03') {
      return await PPE_BASIC_03_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef
      );
    }

    // BUD_BASIC_01인 경우 PrintLogic1 실행
    if (tabId === 'BUD_BASIC_01') {
      return await BUD_BASIC_01_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef
      );
    }

    // BUD_BASIC_02인 경우 printType에 따라 다른 인쇄 함수 실행
    if (tabId === 'BUD_BASIC_02') {
      // printItem이 있고 printType이 '2'이면 PrintLogic3 실행 (예산안)
      if (printItem && printItem.printType === '2') {
        // rowData2는 현재 상태 관리가 없으므로 rowData1을 사용
        // TODO: 실제로는 rowData2를 별도로 관리해야 할 수 있음
        return await BUD_BASIC_02_PrintLogic3(
          documentData,
          dispatch,
          setLoading,
          tabLabels.length > 0
            ? rowDataList[currentTabIndex] || []
            : rowData1 || [],
          searchRef
        );
      }
      // 기본값 또는 'detail'인 경우 PrintLogic1 실행 (예산편성(세부))
      return await BUD_BASIC_02_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef,
        [] // changedRowData1은 현재 상태 관리가 없으므로 빈 배열
      );
    }

    // SUB_BASIC_01인 경우 PrintLogic1 실행
    if (tabId === 'SUB_BASIC_01') {
      return await SUB_BASIC_01_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef
      );
    }

    // SUB_BASIC_02인 경우 PrintLogic1 실행
    if (tabId === 'SUB_BASIC_02') {
      return await SUB_BASIC_02_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef,
        userInfo
      );
    }

    // SUB_BASIC_03인 경우 PrintLogic1 실행
    if (tabId === 'SUB_BASIC_03') {
      return await SUB_BASIC_03_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        searchRef,
        imgRef
      );
    }

    // LegalCompliance (법규준수평가)인 경우 PrintLogic1 실행 (탭이 없는 메뉴)
    if (currentMenuId === 'LegalCompliance') {
      return await LEG_BASIC_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        rowData1 || [], // 탭이 없으므로 rowData1 사용
        [], // modalRowData1은 현재 상태 관리가 없으므로 빈 배열 (내부에서 조회)
        userInfo, // user
        searchRef,
        imgRef
      );
    }

    // SeriousAccidentAct (중대재해처벌법 이행관리)인 경우 PrintLogic1 실행 (탭이 없는 메뉴)
    if (currentMenuId === 'SeriousAccidentAct') {
      return await SER_BASIC_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        rowData1 || [], // 탭이 없으므로 rowData1 사용
        baseCustInfo,
        searchRef
      );
    }

    // SafetyCommittee (산업안전보건위원회)인 경우 PrintLogic3 실행
    if (currentMenuId === 'SafetyCommittee') {
      // printItem이 있고 printType이 '1'이면 회의록 인쇄 (gubun='1', 년도, 분기 전달)
      if (printItem && printItem.printType === '1') {
        const _gubun = '1';
        // _value1은 년도 (searchRef.current.currentYear)
        const _value1 =
          searchRef?.current?.currentYear ||
          new Date().getFullYear().toString();
        // _value2는 분기 (searchRef.current.quarter)
        const _value2 =
          searchRef?.current?.quarter ||
          Math.ceil((new Date().getMonth() + 1) / 3).toString();

        return await SAC_BASIC_PrintLogic3(
          _gubun,
          _value1,
          _value2,
          documentData,
          dispatch,
          setLoading,
          tabLabels.length > 0
            ? rowDataList[currentTabIndex] || []
            : rowData1 || [],
          searchRef,
          imgRef
        );
      }
      // printItem이 없으면 상단 인쇄 버튼 클릭 (gubun='0', null, null)
      const _gubun = '0';
      const _value1 = null;
      const _value2 = null;

      return await SAC_BASIC_PrintLogic3(
        _gubun,
        _value1,
        _value2,
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef,
        imgRef
      );
    }

    // SAM_BASIC_02인 경우 PrintLogic1 실행
    if (tabId === 'SAM_BASIC_02') {
      return await SAM_BASIC_02_PrintLogic1(documentData, dispatch, setLoading);
    }

    // SAF_BASIC_02인 경우 PrintLogic1 실행
    if (tabId === 'SAF_BASIC_02') {
      return await SAF_BASIC_02_PrintLogic1(documentData, dispatch, setLoading);
    }

    // TRA_CUSTOM_01인 경우 PrintLogic1 실행
    if (tabId === 'TRA_CUSTOM_01') {
      return await TRA_CUSTOM_01_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        searchRef
      );
    }

    // TRA_CUSTOM_02인 경우 PrintLogic1 실행
    if (tabId === 'TRA_CUSTOM_02') {
      return await TRA_CUSTOM_02_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef
      );
    }

    // TRA_BASIC_01인 경우 PrintLogic1 실행
    if (tabId === 'TRA_BASIC_01') {
      return await TRA_BASIC_01_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef
      );
    }

    // SAT_BASIC_01인 경우 PrintLogic1 실행
    if (tabId === 'SAT_BASIC_01') {
      return await SAT_BASIC_01_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef
      );
    }

    // SAT_BASIC_02인 경우 PrintLogic1 실행
    if (tabId === 'SAT_BASIC_02') {
      return await SAT_BASIC_02_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef
      );
    }

    // SAT_BASIC_03인 경우 PrintLogic1 실행
    if (tabId === 'SAT_BASIC_03') {
      return await SAT_BASIC_03_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef
      );
    }

    // SAT_BASIC_04인 경우 PrintLogic1 실행
    if (tabId === 'SAT_BASIC_04') {
      return await SAT_BASIC_04_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef
      );
    }

    // SAT_BASIC_05인 경우 PrintLogic1 실행
    if (tabId === 'SAT_BASIC_05') {
      return await SAT_BASIC_05_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef
      );
    }

    // HAM_BASIC_02인 경우 PrintLogic1 실행 (printGridData와 userInfo 전달)
    if (tabId === 'HAM_BASIC_02') {
      return await HAM_BASIC_02_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        userInfo
      );
    }

    // SAP_BASIC_01인 경우 조직도 이미지 생성 및 미리보기
    if (tabId === 'SAP_BASIC_01') {
      return await SAP_BASIC_01_PrintLogic1(documentData);
    }

    // SAP_BASIC_02인 경우 PrintLogic1 실행
    if (tabId === 'SAP_BASIC_02') {
      // companyInfo는 현재 상태 관리가 없으므로 빈 배열로 전달
      // TODO: 필요시 companyInfo 상태 추가
      return await SAP_BASIC_02_PrintLogic1(
        documentData,
        dispatch,
        setLoading,
        tabLabels.length > 0
          ? rowDataList[currentTabIndex] || []
          : rowData1 || [],
        searchRef,
        custList,
        baseCompanyInfo,
        userInfo,
        imgRef
      );
    }

    // 다른 other 타입 케이스는 여기에 추가
    console.error('OtherLogic1: 지원하지 않는 탭 ID입니다.', { tabId });
    return null;
  };

  // DTL 상세 조회 함수
  const HandleDetailSearchLogic = async (idValue) => {
    const currentTabIndex = tabLabels.length > 0 ? value : 0;
    const currentTabId = tabList[currentTabIndex]?.tabId || null;

    // SAP_BASIC_02인 경우 SearchLogic3 실행
    if (currentTabId === 'SAP_BASIC_02') {
      return await SAP_BASIC_02_SearchLogic3(idValue, dispatch, setLoading);
    }

    return null;
  };

  // DTL 상세 인쇄 함수
  const HandleDetailPrintLogic = async (selectedItem, custCd, userInfo) => {
    const currentTabIndex = tabLabels.length > 0 ? value : 0;
    const currentTabId = tabList[currentTabIndex]?.tabId || null;

    // SAP_BASIC_02인 경우 PrintLogic2 실행
    if (currentTabId === 'SAP_BASIC_02') {
      return await SAP_BASIC_02_PrintLogic2(
        selectedItem,
        custCd,
        userInfo,
        dispatch,
        setLoading
      );
    }

    return null;
  };
  //#endregion

  // activeStep이 1일 때만 렌더링
  if (activeStep !== 1) {
    return null;
  }

  return (
    <div className="wrap">
      <M_DCM_BASIC_01
        userInfo={userInfo}
        rowData1={rowData1}
        rowDataList={rowDataList}
        tabLabels={tabLabels}
        value={value}
        setValue={setValue}
        onBack={onBack}
        custList={custList}
        onChipClick={HandleChipClick}
        searchRef={searchRef}
        onSearch={() => {
          // 탭이 있는 경우 현재 선택된 탭만 조회
          if (tabLabels.length > 0) {
            SearchLogic2(value);
          } else {
            SearchLogic2();
          }
        }}
        depList={depList}
        onDepListChange={SearchDep}
        tabConfigs={tabConfigs}
        onPrintLogic={PrintLogic1}
        onOtherLogic={OtherLogic1}
        onDetailSearchLogic={HandleDetailSearchLogic}
        onDetailPrintLogic={HandleDetailPrintLogic}
        subMenuId={subMenuId}
        mainMenuId={mainMenuId}
      />
      <Loading open={loading} />
    </div>
  );
}
